<template>
  <el-main class="pcs">
    <PcsBanner :dataimgs="dataimgs" />
    <BannerBottom :data="bannerBottomItems" />
    <IntroPCS :data="intros" />
    <ScenePCS :data="scenes" />
  </el-main>
</template>

<script>
import PcsBanner from "./PcsBanner";
import BannerBottom from "./BannerBottom";
import IntroPCS from "./IntroPCS";
import ScenePCS from "./ScenePCS";
export default {
  name: "PortalPCS",
  components: {
    PcsBanner,
    BannerBottom,
    IntroPCS,
    ScenePCS
  },
  data() {
    return {
      dataimgs: [
        {
          id: 0,
          url: "https://account.mopaas.com/registerPublic.jsp",
          src1: require("@/assets/images/mopaasbanner.jpg"),
          src2: require("@/assets/images/mopaasbanner-m.png"),
          title: "颠覆传统的应用交付模式",
          content: ["打造企业级应用云平台"],
          btn: "立即注册",
          price: "产品定价 >",
          priceUrl: "/price",
          priceVisible :false
        }
      ],
      bannerBottomItems: [
        {
          id: 0,
          content: "开放",
          img: require("@/assets/images/pcs-icon1.jpg")
        },
        {
          id: 1,
          content: "敏捷",
          img: require("@/assets/images/pcs-icon2.jpg")
        },
        {
          id: 2,
          content: "安全",
          img: require("@/assets/images/pcs-icon3.jpg")
        }
      ],
      intros: [
        {
          id: 0,
          title: "一站式解决方案",
          src: require("@/assets/images/yunsheng01.jpg"),
          contents: [
            "可以高度整合IaaS-PaaS云平台",
            "灵活高效容器化资源管理",
            "敏捷的应用持续交付",
            "多维的安全防护"
          ]
        },
        {
          id: 1,
          title: "开放的应用云平台",
          src: require("@/assets/images/yunsheng02.jpg"),
          contents: [
            "微服务架构：分布，隔离和安全",
            "容器和编排：Cloud Foundry、Docker 和 Kubernetes 等",
            "融合 IaaS-PaaS 的管理",
            "不断演化融合最新技术以满足变化的需求"
          ]
        },
        {
          id: 3,
          title: "开放的生态体系",
          src: require("@/assets/images/yunsheng03.jpg"),
          contents: [
            "开放中立：不绑定任何特定的技术和服务",
            "灵活地接入和整合第三方优质服务和工具",
            "战略合作：IaaS、工具/流程、服务插件、SaaS"
          ]
        }
      ],
      scenes: [
        {
          id: 0,
          title: "开发测试",
          src: require("@/assets/images/yunpic1.jpg"),
          desc:
            "用多种应用运行环境和中间件服务，自动化配置和部署。可直接连接开发工具至平台。",
          contents: [
            {
              title: "发布方式",
              content: "可执行包、源码、镜像"
            },
            {
              title: "代码托管",
              content: "提供Git仓库，也可通过第三方Git仓库进行托管"
            },
            {
              title: "持续集成",
              content:
                "应用与源码仓库关联，实现将源代码自动发布至平台运行的整个流程"
            }
          ]
        },
        {
          id: 1,
          title: "应用交付",
          src: require("@/assets/images/yunpic2.jpg"),
          contents: [
            {
              title: "灰度发布",
              content:
                "采用灰度发布策略，实现应用发布的平滑过渡保证整体系统的稳定性"
            },
            {
              title: "版本回滚",
              content: "一旦应用出现问题，能及时回滚到之前的版本"
            }
          ]
        },
        {
          id: 2,
          title: "自动化运维",
          src: require("@/assets/images/yunpic3.jpg"),
          contents: [
            {
              title: "监控报警",
              content: "提供健康检查机制，自动检测性能指标，方便及时处理"
            },
            {
              title: "故障恢复",
              content: "应用出现故障，实例自动迁移或重启，减小人工投入和成本"
            },
            {
              title: "弹性伸缩",
              content:
                "结合用户策略，联合监控数据进行弹性扩展伸缩，实现资源合理利用"
            },
            {
              title: "性能管理",
              content: "提供多种数据图表，性能指标一目了然，精确定位性能缺陷"
            }
          ]
        }
      ]
    };
  }
};
</script>

<style>
.pcs .pcs-banner .try-btn-area .el-button {
  display: none;
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/PortalPCS.vue